module.exports = __webpack_public_path__ + "static/media/lightUploading.d1d37244.svg";